import "ngstorage";

class PostjobbulkController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    SecurityService,
    CompaniesService,
    $timeout,
    $rootScope,
    EnvService,
    ngProgressFactory,
    $scope,
    $location
  ) {
    this.name = "postjobbulk";
    $localStorage.activeStateName = "postjobbulk";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$auth = AuthService;
    this.showCSV = true;
    this.$companies = CompaniesService;
    this.sheet = null;
    this.ui_components = {};
    this.jobArrayHolder = [];
    this.currentUser = this.$auth.getUserData();
    this.showLoader = false;
    this.loadUsers();
    this.jobsWithShiftsBeforeNow = [];
    this.getJobbleTypes();
    this.jobsWithWrongManagers = [];
    this.jobsWithWrongJT = [];
    console.log("postjobbulk");
  }

  showExampleCSV() {
    if (this.showCSV) {
      this.showCSV = false;
    } else {
      this.showCSV = true;
    }
  }

  setSpinner() {
    var _this = this;

    console.log("setSpinner");

    _this.showLoader = true;
  }

  loadWorksheet(sheet) {
    var _this = this;

    _this.setLoader();
    _this.setSpinner();
    _this.spread_sheet_error = false;

    _this.$timeout(function () {
      let file = sheet.target.result;
      let workbook = XLSX.read(file, {
        type: "binary",
        cellText: false,
        cellDates: true,
      });

      let sheetName = workbook.SheetNames[0];

      if (!sheetName) {
        alert("The file format is not correct.");
        return;
      }
      sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
        header: 1,
        raw: false,
        dateNF: "mm/dd/yyyy",
      });

      _this.validateAllFieldsAreNotEmpty(sheet);
    }, 300);
  }

  validateAllFieldsAreNotEmpty(sheet) {
    var _this = this;
    var sheet_after_cleanse = [];
    var errored_rows = [];

    try {
      sheet.forEach(function (row, i) {
        let row_build = {};
        let keys = Object.keys(row);
        let values = keys.map(function (v) {
          return row[v];
        });
        let pay = null;
        let questions = [];
        let process = true;

        if (i > 0) {
          let keysLength = keys.length;
          keys.forEach(function (key, x) {
            key = key.trim();

            switch (x) {
              case 0:
                row_build.EventName = values[0];
              case 1:
                row_build.Address = values[1];
              case 2:
                row_build.City = values[2];
              case 3:
                row_build.State = values[3];
              case 4:
                row_build.Zip = _this.testZipCode(values[4]);
              case 5:
                row_build.StartDay = values[5];
              case 6:
                row_build.StartTime = values[6];
              case 7:
                row_build.EndTime = values[7];
              case 8:
                row_build.Sunday = values[8];
              case 9:
                row_build.Monday = values[9];
              case 10:
                row_build.Tuesday = values[10];
              case 11:
                row_build.Wendesday = values[11];
              case 12:
                row_build.Thursday = values[12];
              case 13:
                row_build.Friday = values[13];
              case 14:
                row_build.Saturday = values[14];
              case 15:
                row_build.Weeks = parseInt(values[15]);
              case 16:
                row_build.UnpaidBreak = parseInt(values[16]);
              case 17:
                row_build.Openings = parseInt(values[17]);
              case 18:
                row_build.DescriptionFull = values[18];
                row_build.Description = values[18].substring(0, 40) + "...";
              case 19:
                row_build.DressCodeFull = values[19];
                row_build.DressCode = values[19].substring(0, 40) + "...";
              case 20:
                row_build.PayPerHour = parseInt(values[20]);
              case 21:
                row_build.JobType = values[21];
              case 22:
                row_build.HiringManager = parseInt(values[22]);
              case 23:
                row_build.ArrivalInstructions = values[23];
              case 24:
                row_build.OnSiteName = values[24];
              case 25:
                row_build.OnSiteNumber = values[25];
              case 26:
                row_build.Req1 = values[26];
              case 27:
                row_build.Req2 = values[27];
              case 28:
                row_build.Req3 = values[28];
              case 29:
                row_build.Req4 = values[29];
              case 30:
                row_build.Req5 = values[30];
              case 31:
                //row_build.W2 = values[31]?.trim().toUpperCase();
            }

            if (x + 1 === keysLength) {
              console.log("we are at the end");
              _this.formatDatesForEachRow(row_build);
            }
          });
          sheet_after_cleanse.push(row_build);
        }
      });
    } catch (err) {
      console.log("catch error");
      console.dir(err);
    } finally {
      _this.sheet = sheet_after_cleanse;
      this.$scope.$apply(); // Need this to update angular with the changes
      this.mapSheetToJSON();
      //_this.groupJobs(sheet_after_cleanse);
    }
  }

  formatDatesForEachRow(job) {
    var _this = this;

    console.log("formatDatesForEachRow");
    console.dir(job);

    let shifts = [];
    let daysInWeek = [];
    let start_date = job.StartDay;
    let start_time = job.StartTime;
    //let end_date = job.EndDay;
    let end_time = job.EndTime;
    let startDateTime = new Date(start_date + " " + start_time);
    //let endDateTime = new Date(end_date + " " + end_time);
    let shiftDuration;
    let shiftEndTimeMoment = moment(new Date(start_date + " " + end_time));
    let startTimeMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
    shiftDuration = shiftEndTimeMoment.diff(startTimeMoment, "minutes", true);
    let dayOfWeek = startTimeMoment.day();
    console.log("Day of week");
    console.dir(dayOfWeek);
    console.log("shiftDuration");
    console.dir(shiftDuration);

    /* TODO: need shift duration */
    //calculate shift duration

    let beginningOfDayMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
    let beginningOfWeekMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
    let beginningOfDayMomentConversion = beginningOfDayMoment.startOf("day");
    let differenceInMinutesFromStartOfDayToStartOfShift = startTimeMoment.diff(beginningOfDayMomentConversion, "minutes", true);
    let startOfWeek = beginningOfWeekMoment.startOf("week");
    let startDayOfTheWeekForJob;

    let timeData = {};
    timeData.startOfWeek = startOfWeek;
    timeData.shiftDuration = shiftDuration;
    timeData.differenceInMinutesFromStartOfDayToStartOfShift = differenceInMinutesFromStartOfDayToStartOfShift;
    timeData.beginningOfDayMomentConversion = beginningOfDayMomentConversion;
    timeData.beginningOfWeekMoment = beginningOfWeekMoment;
    timeData.beginningOfDayMoment = beginningOfDayMoment;
    timeData.startTimeMoment = startTimeMoment;
    timeData.shiftEndTimeMoment = shiftEndTimeMoment;
    console.log("dayOfWeek");
    //console.dir(startOfWeek);
    console.dir(dayOfWeek);
    console.dir(typeof dayOfWeek);

    if (dayOfWeek === 0) {
      startDayOfTheWeekForJob = "Sunday";
    } else if (dayOfWeek === 1) {
      startDayOfTheWeekForJob = "Monday";
    } else if (dayOfWeek === 2) {
      startDayOfTheWeekForJob = "Tuesday";
    } else if (dayOfWeek === 3) {
      startDayOfTheWeekForJob = "Wendesday";
    } else if (dayOfWeek === 4) {
      startDayOfTheWeekForJob = "Thursday";
    } else if (dayOfWeek === 5) {
      startDayOfTheWeekForJob = "Friday";
    } else if (dayOfWeek === 6) {
      startDayOfTheWeekForJob = "Saturday";
    } else if (dayOfWeek === 7) {
      startDayOfTheWeekForJob = "Sunday1";
    }

    console.log("startDayOfTheWeekForJob");
    console.dir(startDayOfTheWeekForJob);

    //
    //the amount of minutes needed to be added to the start of each day
    //

    console.dir(differenceInMinutesFromStartOfDayToStartOfShift);
    timeData.startDayOfTheWeekForJob = startDayOfTheWeekForJob;
    timeData.startDayOfTheWeekForJob = startDayOfTheWeekForJob;

    job.shifts = this.constructShifts(job, timeData);

    console.log("shifts in job?");
    console.dir(job);
  }

  testZipCode(code) {
    if (typeof code === 'string' || code instanceof String) {
      if (code.length === 4) {
        code = "0" + code;
      }
    }

    return code;
  }

  constructShifts(job, timeData) {
    console.log("constructShifts");
    console.dir(this);
    console.dir(job);
    console.dir(timeData);
    console.dir(timeData.differenceInMinutesFromStartOfDayToStartOfShift);
    console.dir(timeData.startDayOfTheWeekForJob);

    let shifts;

    if (timeData.startDayOfTheWeekForJob === "Sunday") {
      shifts = this.addWorkDays("Sunday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Monday") {
      shifts = this.addWorkDays("Monday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Tuesday") {
      shifts = this.addWorkDays("Tuesday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Wendesday") {
      shifts = this.addWorkDays("Wendesday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Thursday") {
      shifts = this.addWorkDays("Thursday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Friday") {
      shifts = this.addWorkDays("Friday", job, timeData);
    } else if (timeData.startDayOfTheWeekForJob === "Saturday") {
      shifts = this.addWorkDays("Saturday", job, timeData);
    }

    return shifts;
  }

  addDays(job, start, end, days) {
    console.log("addDays");
    console.dir(job);

    let shift = {};

    shift.timeInterval = {};
    shift.contactInfo = {};

    shift.unpaidBreak = job.UnpaidBreak;
    shift.overnight = false;
    shift.timeInterval.startTime = moment(start).add(days, "day").format();
    shift.timeInterval.endTime = moment(end).add(days, "day").format();
    shift.contactInfo.city = job.City;
    shift.contactInfo.state = job.State;
    shift.contactInfo.streetLine1 = job.Address;
    shift.contactInfo.zipCode = job.Zip;

    console.log("shift being returned from add days");
    console.dir(shift);

    return shift;
  }

  addWorkDays(startDay, job, timeData) {
    let shifts = [];
    let shift = {};
    const startOfFirstShift = timeData.startTimeMoment.format();
    const endOfFirstShift = timeData.shiftEndTimeMoment.format();
    try {
      if (startDay === "Monday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        //Weekend logic
        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Tuesday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        //Weekend logic
        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Wendesday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        //Weekend logic
        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Thursday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        //Weekend logic
        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Friday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        //Weekend logic
        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Saturday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        //Weekend logic
        if (job.Sunday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      } else if (startDay === "Sunday") {
        shift.timeInterval = {};
        shift.timeInterval.startTime = timeData.startTimeMoment.format();
        shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
        shift.contactInfo = {};
        shift.contactInfo.city = job.City;
        shift.contactInfo.state = job.State;
        shift.contactInfo.streetLine1 = job.Address;
        shift.contactInfo.zipCode = job.Zip;
        shift.unpaidBreak = job.UnpaidBreak;
        shift.overnight = false;

        shifts.push(shift);
        shift = {};

        //Weekend logic
        if (job.Monday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
          shifts.push(shift);
          shift = {};
        }

        if (job.Tuesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
          shifts.push(shift);
          shift = {};
        }

        if (job.Wendesday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
          shifts.push(shift);
          shift = {};
        }

        if (job.Thursday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
          shifts.push(shift);
          shift = {};
        }

        if (job.Friday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
          shifts.push(shift);
          shift = {};
        }

        if (job.Saturday.toUpperCase() === "YES") {
          shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
          shifts.push(shift);
          shift = {};
        }
      }
    } catch (err) {
      console.log("error caught");
      console.dir(err);
    } finally {
      console.log("what do we have for shifts");
      console.dir(shifts);
      return shifts;
    }
  }

  loadUsers() {
    var _this = this;
    _this.$companies.loadUsers().then(
      function (response) {
        console.log("who are the  users..");
        console.dir(response.data);
        _this.companyUsers = response.data;
      },
      function (error) {
        alert("error getting company users");
      }
    );
  }

  getHiringManager(managerId) {
    var _this = this;

    return parseInt(managerId);
  }

  checkForHiringManager() {
    var _this = this;

    _this.sheet.forEach(function (row, index) {
      _this.findHiringManager(row.HiringManager, row);
    });
  }

  findHiringManager(managerId, job) {
    var _this = this;

    console.log("findHiringManager");
    console.dir(managerId);

    let m_id = null;

    let m = _.find(_this.companyUsers, function (o) {
      return o.id === managerId;
    });

    console.log("what is m?");
    console.dir(m);

    if (!m) {
      job.isBefore = true;
      _this.jobsWithWrongManagers.push(job);
    }
  }

  getJobbleType(jt, job) {
    var _this = this;

    console.log("what are the jobbble types");
    console.dir(_this.jobbleTypes);
    console.dir(jt);

    let j_id = null;

    let j = _.find(_this.jobbleTypes, function (o) {
      return o.name === jt;
    });

    console.log("missing jobble type...");
    console.dir(jt);
    console.dir(j);

    if (!j) {
      //alert("Invalid Missing Job Type for job " + job.EventName + ". Adding placeholder JobbleType. Please edit after upload. ");
      console.log("what are we pushing here");
      job.isBefore = true;
      _this.jobsWithWrongJT.push(job);
      console.dir(_this.jobsWithWrongJT);
      j_id = 1;
    } else {
      j_id = j.id;
    }

    console.log("what is j?");
    console.dir(j);

    return j_id;
  }

  formatPayRate(pay) {
    var _this = this;

    let cents = pay * 100;

    return cents;
  }

  createNewParentJob(job) {
    var _this = this;

    let freshJob = {};
    console.log("createNewParentJob");
    console.dir(job);
    console.log("what is the current user");
    console.dir(_this.currentUser);
    freshJob.jobble = {};
    freshJob.jobble.numberOfOpenings = parseInt(job.Openings);
    //freshJob.identifier = job.JobID;
    freshJob.jobble.name = job.EventName;
    freshJob.jobble.description = job.DescriptionFull;
    freshJob.jobble.dressCode = job.DressCodeFull;
    freshJob.jobble.jobbleType = _this.getJobbleType(job.JobType, job);
    freshJob.jobble.isPublished = true;
    freshJob.jobble.payPerHour = _this.formatPayRate(job.PayPerHour);
    freshJob.jobble.manager = _this.getHiringManager(job.HiringManager);
    freshJob.jobble.subEvent = {};
    freshJob.jobble.subEvent.name = job.EventName;
    freshJob.jobble.subEvent.contactInfo = {};
    freshJob.jobble.subEvent.contactInfo.streetLine1 = job.Address;
    freshJob.jobble.subEvent.contactInfo.city = job.City;
    freshJob.jobble.subEvent.contactInfo.state = job.State;
    freshJob.jobble.subEvent.contactInfo.zipCode = job.Zip;
    freshJob.jobble.subEvent.event = {};
    freshJob.jobble.subEvent.event.name = job.EventName;
    if (job.W2 === "YES") {
      freshJob.jobble.subEvent.event.isW2 = true;
    } else {
      freshJob.jobble.subEvent.event.isW2 = false;
    }
    freshJob.jobble.subEvent.event.description = job.DescriptionFull;
    freshJob.jobble.subEvent.event.eventType = 1;
    freshJob.jobble.subEvent.event.isPublished = true;
    freshJob.jobble.subEvent.event.company = _this.currentUser.company.id;
    freshJob.jobble.subEvent.event.isSourcingPost = false;
    freshJob.jobble.subEvent.event.weeks = parseInt(job.Weeks);
    freshJob.jobble.subEvent.event.arrivalInstructions = job.ArrivalInstructions;
    freshJob.jobble.subEvent.event.onsiteManagerName = job.OnSiteName;
    freshJob.jobble.subEvent.event.onsiteManagerNumber = job.OnSiteNumber;
    freshJob.jobble.subEvent.event.requirements = _this.buildRequirements(job);
    freshJob.jobble.shifts = job.shifts;

    _this.jobArrayHolder.push(freshJob);
  }

  buildRequirements(job) {
    console.log("buildRequirements");
    console.dir(job);

    let requirements = [];
    let requirement = {};

    if (job.Req1) {
      requirements.push({position: 1, name: job.Req1});
    }

    if (job.Req2) {
      requirements.push({position: 2, name: job.Req2});
    }

    if (job.Req3) {
      requirements.push({position: 3, name: job.Req3});
    }

    if (job.Req4) {
      requirements.push({position: 4, name: job.Req3});
    }

    if (job.Req5) {
      requirements.push({position: 5, name: job.Req3});
    }

    return requirements;
  }

  getQuestions(questions) {
    var _this = this;

    let questionArray = [];

    questions.forEach(function (q, i) {
      let index = i + 1;
      let next_question = {};
      next_question.name = "Question " + index;
      next_question.question = q;
      next_question.questionType = 1;
      questionArray.push(next_question);
    });

    return questionArray;
  }

  mapSheetToJSON() {
    console.log("mapSheetToJSON");
    console.dir(this.sheet);

    var _this = this;

    let index;

    try {
      _this.sheet.forEach(function (row, i) {
        index = i + 1;
        _this.createNewParentJob(row);
      });
    } catch (err) {
      console.log("error");
      console.dir(err);
    } finally {
      //_this.checkShiftsForTimes();
      _this.checkForHiringManager();
      console.log("_this.jobArrayHolder");
      console.dir(_this.jobArrayHolder);

      if (_this.jobArrayHolder.length === 0) {
        _this.displayLoadingError();
      }

      _this.unSetLoader();
    }
  }

  checkShiftsForTimes() {
    var _this = this;

    try {
      _this.sheet.forEach(function (job, index) {
        _this.testStartTime(job);
      });
    } catch (err) {
      console.log("error");
      console.dir(err);
    } finally {
      _this.unSetLoader();
      _this.showLoader = false;
    }
  }

  testStartTime(job) {
    var _this = this;

    let isBefore = moment(job.startTimeFormatted).isBefore(moment());

    if (isBefore) {
      job.isBefore = true;
      _this.jobsWithShiftsBeforeNow.push(job);
    }
  }

  displayLoadingError() {
    var _this = this;

    _this.spread_sheet_error = true;
  }

  nestShiftIntoExistingJob(job, id) {
    var _this = this;

    let existingJob = _.find(_this.jobArrayHolder, function (o) {
      return o.identifier === id;
    });

    let newShift = {};

    newShift.timeInterval = {};
    newShift.contactInfo = {};
    newShift.timeInterval.startTime = job.startTimeFormatted;
    newShift.timeInterval.endTime = job.endTimeFormatted;
    newShift.contactInfo.streetLine1 = job.Address;
    newShift.contactInfo.city = job.City;
    newShift.contactInfo.state = job.State;
    newShift.contactInfo.zipCode = job.Zip;

    existingJob.jobble.shifts.push(newShift);
  }

  submitJobs() {
    var _this = this;

    _this.setLoader();

    let data = _this.jobArrayHolder;

    _this.$companies.bulkPostJobs(data).then(
      function (response) {
        _this.unSetLoader();
        _this.$timeout(function () {
          _this.unSetLoader();
          $("#bulk-jobs-processing").modal();
        }, 1000);
      },
      function (error) {
        console.log("API Error");
        _this.unSetLoader();
        _this.jobsWithShiftsBeforeNow = [];
        _this.jobsWithWrongManagers = [];
        console.dir(error);
      }
    );
  }

  coupleShiftsTogether(jobs) {
    var _this = this;

    console.log("coupleShiftsTogether");
    console.dir(jobs);
  }

  handleDate(date) {
    var _this = this;
    //console.log("handleDate");
    //console.dir(date);
    return date;
  }

  clearBulkPay() {
    this.sheet = null;
    this.jobsWithShiftsBeforeNow = [];
    this.jobsWithWrongManagers = [];
    this.jobArrayHolder = [];
    this.jobsWithWrongJT = [];
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  getJobbleTypes() {
    var _this = this;

    _this.$auth.getJobbleTypes().then(
      function (data) {
        _this.jobbleTypes = data.data;
      },
      function (data) {
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  closeProcessingModal() {
    var _this = this;

    _this.clearBulkPay();
    _this.$timeout(function () {
      $("#bulk-jobs-processing").modal("toggle");
    });
  }
}

PostjobbulkController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "security",
  "companies",
  "$timeout",
  "$rootScope",
  "env",
  "ngProgressFactory",
  "$scope",
  "$location",
];

export default PostjobbulkController;



// WEBPACK FOOTER //
// ./client/app/components/postevent/postjobbulk/postjobbulk.controller.js